import { take, put, select } from 'redux-saga/effects';
import { LOCATION_CHANGE } from 'react-router-redux';

const LOCATION_HISTORY = 'LOCATION_HISTORY';

const locationHistoryAction = payload => ({
    type: LOCATION_HISTORY,
    payload,
});

const reducer = (state = null, action) => {
    if (action.type === LOCATION_HISTORY) {
        return action.payload;
    }
    return state;
};


export default reducer;

export function* rootSaga() {
    while (true) { // eslint-disable-line no-constant-condition
        const { router: { location } } = yield select();
        yield take(LOCATION_CHANGE);
        if (location && location.pathname !== '/more-info') {
            yield put(locationHistoryAction(location));
        }
    }
}



// WEBPACK FOOTER //
// ./src/client/redux/location-history.js